/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Manage_MenuInputs */



/**
* | output |
* | --- |
* | "Manage Speakers" |
*
* @param {Speakers_Manage_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_manage_menu = /** @type {((inputs?: Speakers_Manage_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Manage_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Manage Speakers")
	if (locale === "de") return /** @type {LocalizedString} */ ("Manage Speakers")
	if (locale === "it") return /** @type {LocalizedString} */ ("Manage Speakers")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Manage Speakers")
	if (locale === "es") return /** @type {LocalizedString} */ ("Manage Speakers")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Manage Speakers")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Manage Speakers")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Manage Speakers")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Manage Speakers")
	return /** @type {LocalizedString} */ ("Manage Speakers")
});